<template>
  <div class="content-wrapper summary-results pt-4">
    <div class="container" style="position: relative">
      <div
        id="configuration_id_wrapper"
        style="text-align: right; font-style: italic"
      ></div>
      <div class="center">
        <div class="xs-text uppercase">Introducing your custom</div>
        <h3 class="mt-3">{{ bike.name }}</h3>

        <div class="info-items d-flex justify-content-between mt-5 pdf-item">
          <div class="info-item">
            <div class="xs-text uppercase">Material</div>
            <h5>{{ getMaterialNameById(bike.material_id) }}</h5>
          </div>
          <div class="info-item">
            <div class="xs-text uppercase">Frame weight</div>
            <h5>{{ bike.frame_weight }}Kg</h5>
          </div>
          <div class="info-item">
            <div class="xs-text uppercase">Total inc. accessories</div>
            <h5>{{ formatPrice(price) }}<a href="#price_asterisc">*</a></h5>
          </div>
          <div
            class="info-item"
            v-if="
              results.colour.primaryColor != null ||
              results.colour.secondaryColor != null
            "
          >
            <div class="xs-text uppercase">Colour</div>
            <h5>
              {{ results.colour.primaryColor }}
              <span v-if="results.colour.secondaryColor != null">/</span>
              {{ results.colour.secondaryColor }}
            </h5>
          </div>
          <div
            class="info-item"
            v-if="
              results.frame.finish != null && results.frame.finish.name != null
            "
          >
            <div class="xs-text uppercase">Frame finish</div>
            <h5>{{ results.frame.finish.name }}</h5>
          </div>
        </div>

        <div
          class="frame-text-wrapper"
          v-if="
            results.frame.finish != null &&
            results.frame.title.text != null &&
            results.frame.title.family != null
          "
        >
          <div class="info-item" v-if="results.frame.finish.name != null">
            <div class="xs-text uppercase">Personal title</div>
            <h5>
              <span
                :style="{
                  'font-family': results.frame.title.family.font,
                  'font-weight': results.frame.title.family.bold
                    ? '600'
                    : '400',
                  'font-style': results.frame.title.family.italic
                    ? 'italic'
                    : 'none',
                  'text-transform': results.frame.title.family.uppercase
                    ? 'uppercase'
                    : 'none',
                }"
                >"{{ results.frame.title.text }}"</span
              >
            </h5>
          </div>
        </div>

        <buttonset
          class="no-print"
          :loggedUser="loggedUser"
          :isAdmin="isAdmin"
          v-on:save-configuration="saveConfiguration"
          v-on:download-configuration="downloadConfiguration"
          v-on:ask-information="askInformation"
          v-on:confirm-configuration="confirmConfiguration"
          v-on:back-to-configurator="backToConfigurator"
          v-on:save-configuration-as-default="saveConfigurationAsDefault"
          v-on:configure-another-bike="configureAnother"
        ></buttonset>

        <div class="imager-wrapper pdf-item no-print">
          <imagerComponent
            :results="results"
            :bikeConfiguration="bikeConfiguration"
            :componentsConfig="componentsConfig"
            :where="'result'"
          ></imagerComponent>
        </div>

        <div
          id="bike_image_pdf"
          class="imager-wrapper pdf-item avoid"
          style="display: none"
        >
          <img :src="bikeImage" style="max-height: 400px; max-width: 100%" />
        </div>
        <!-- <div class="html2pdf__page-break" /> -->

        <!-- <div class="html2pdf__page-break" /> -->

        <div class="specifications">
          <h3 class="mb-5">Your specification</h3>
          <div class="empty-results" v-if="mews.length == 0">
            No components found
          </div>
          <div class="components">
            <div
              class="components-container"
              v-for="(row, rowNum) in mews"
              :key="rowNum"
            >
              <div
                v-if="rowNum % 2 == 0 && rowNum != 0"
                class="custom-margin"
              />

              <div class="row pdf-item specification-row">
                <div
                  class="col-sm-6 col-md-4 component"
                  v-for="(item, index) in row"
                  :key="index"
                >
                  <div class="uppercase xs-text black-bottom-border">
                    {{ item.key == "tyres" ? "tires" : item.key }}
                  </div>
                  <h5 class="my-2">
                    {{ item.data.name }}
                    <span v-if="item.data.measure"
                      >({{ item.data.measure }})</span
                    >
                  </h5>
                  <div
                    class="image"
                    v-if="item.data.image != null"
                    v-on:click="editComponent(item.key)"
                  >
                    <img :src="'/storage/' + item.data.image" />
                  </div>
                  <div
                    class="image"
                    :style="{
                      'background-image':
                        'url(/configurator/component-placeholder.png)',
                      'background-size': '120px',
                    }"
                    v-else
                    v-on:click="editComponent(item.key)"
                  ></div>
                  <div class="no-print">
                    <small>Click on image to edit component</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <buttonset
          class="no-print"
          v-on:save-configuration="saveConfiguration"
          v-on:download-configuration="downloadConfiguration"
          v-on:confirm-configuration="confirmConfiguration"
          v-on:back-to-configurator="backToConfigurator"
          v-on:ask-information="askInformation"
          v-on:configure-another-bike="configureAnother"
        ></buttonset>
        <div id="price_asterisc">
          * All prices displayed on our website are meant for direct clients of Passoni Titanio Societa Benefit s.r.l., with VAT included at the Italian rate. We operate a point of sale at our Atelier in Vimercate (Milano). Shipping costs and any applicable local duties will be calculated with our clients for each project, depending on delivery method and timing.
        </div>
        <div id="social-info">
          Congratulations on choosing Passoni for your made-to-measure bike.
          <br />
          This PDF is your guide to our powerful configurator, where you can
          customize every detail of your dream bicycle. <br />
          Discover a range of options tailored to your preferences and riding
          style. From frame geometry to finishes, create a truly unique
          masterpiece that reflects your passion. <br />
          Our intuitive instructions and visuals make the configurator easy to
          use. Our experts are here to assist you, ensuring a seamless and
          enjoyable experience. For any further information or inquiries about
          the configuration process, please email us at info@passoni.it. <br />
          Stay connected with us on Instagram and Facebook to join our
          passionate cycling community and stay updated on the latest news and
          inspirations. <br />
          The Passoni Team <br />
          Follow us: <br />
          Instagram: @passoni_titanio <br />
          Facebook: PassoniBikes
        </div>
        <div class="footer no-print">
          <div class="row">
            <div class="col-md-4">
              <h5>Customer service</h5>
              <ul>
                <li>
                  <a target="_blank" href="https://passoni.com/delivery"
                    >Delivery</a
                  >
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://passoni.com/storage/documents/PASSONIRETURN.pdf"
                    >Returns &amp; exchanges</a
                  >
                </li>
                <li>
                  <a target="_blank" href="https://passoni.com/privacy-policy"
                    >Privacy policy</a
                  >
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://passoni.com/terms-and-conditions"
                    >Terms &amp; conditions</a
                  >
                </li>
              </ul>
            </div>
            <div class="col-md-4 align-self-center">
              <img
                src="https://passoni.com/themes/passoni/assets/images/icons/logo-brand.svg"
                alt="Logo Passoni"
                class="icons-dark"
              />
            </div>
            <div class="col-md-4">
              <h5>Connect with Passoni</h5>
              <ul>
                <li>
                  <a
                    target="_blank"
                    href="https://www.instagram.com/passoni_titanio/"
                    >Instagram</a
                  >
                </li>
                <li>
                  <a target="_blank" href="https://facebook.com/PassoniBikes"
                    >Facebook</a
                  >
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.strava.com/clubs/passoni-31360"
                    >Strava</a
                  >
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.flickr.com/photos/passoni/"
                    >Flickr</a
                  >
                </li>
                <li>
                  <a target="_blank" href="https://vimeo.com/passoni">Vimeo</a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://it.linkedin.com/in/passoni-titanio-1a632ba8"
                    >Linkedin</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import imagerComponent from "../../shared/imager.vue";
import buttonset from "./buttonset.vue";

export default {
  name: "summary-results",
  data() {
    return {
      currentPDFi: 1,
    };
  },
  props: [
    "bike",
    "results",
    "price",
    "measures",
    "componentsConfig",
    "bikeConfiguration",
    "loggedUser",
    "bikeImage",
    "isAdmin",
  ],
  components: {
    imagerComponent,
    buttonset,
  },
  computed: {
    mews() {
      var inputArray = Object.keys(this.results)
        .map((key) => {
          if (key != "frame" && key != "colour" && key != "colours") {
            return { data: this.results[key], key: key };
          }
        })
        .filter(function (e) {
          if (e != null && e.data != null && e.data.id != -1) {
            return e;
          }
        });
      var perChunk = 3; // items per chunk

      var result = inputArray.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / perChunk);

        if (!resultArray[chunkIndex]) {
          resultArray[chunkIndex] = []; // start a new chunk
        }

        resultArray[chunkIndex].push(item);
        return resultArray;
      }, []);
      return result;
    },
  },
  methods: {
    getMaterialNameById(id) {
      if (id == 2) {
        return "Carbo-Titanium";
      }
      if (id == 4) {
        return "Titanium";
      }
      if (id == 5) {
        return "Carbon";
      }
      if (id == 6) {
        return "Stainless Steel";
      }
      if (id == 7) {
        return "Carbo-Titanium";
      }
      return null;
    },
    formatPrice: function () {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "EUR",

        minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
      });
      return formatter.format(this.price);
    },
    saveConfiguration: function () {
      this.$emit("save-configuration");
    },
    downloadConfiguration: function () {
      this.$emit("download-configuration");
    },
    askInformation: function () {
      this.$emit("ask-information");
    },
    confirmConfiguration: function () {
      this.$emit("confirm-configuration");
    },
    backToConfigurator: function () {
      this.$emit("back-to-configurator");
    },
    editComponent: function (type) {
      this.$emit("edit-single-component", type);
    },
    configureAnother: function () {
      this.$emit("configure-another-bike");
    },
    saveConfigurationAsDefault: function (n) {
      this.$emit("save-configuration-as-default", n);
    },
  },
  mounted: function () {
    const uri = window.location.search.substring(1);
    const params = new URLSearchParams(uri);
    const configId = params.get("load");
    if (typeof configId != "undefined" && configId != null) {
      document.getElementById("configuration_id_wrapper").innerHTML =
        "Configuration #" + configId;
    }

    // Generate bike png
    if (this.bikeImage == null) {
      let t = this;
      setTimeout(function () {
        // t.$emit("generate-bike-image");
      }, 800);
    }
  },
};
</script>

<style lang="scss" scoped>
.before {
  page-break-before: always;
}
.after {
  page-break-after: always;
}
.avoid {
  page-break-inside: avoid;
}
.summary-results {
  .info-items {
    max-width: 860px;
    margin: 0 auto;

    .info-item {
      width: 19%;
      text-align: center;
    }
  }
  .imager-wrapper {
    /*max-width: 800px;*/
    margin: auto;
  }

  .black-bottom-border {
    border-bottom: 1px solid black;
    padding-bottom: 5px;
  }

  .components {
    .component {
      margin-bottom: 80px;

      @media (max-width: 767px) {
        width: 100%;
        margin: 0 auto;
        margin-bottom: 30px;
      }

      h5 {
        height: 48px;

        @media (max-width: 767px) {
          font-size: 16px;
        }
      }

      .image {
        width: 100%;
        background-size: 90%;
        background-position: center center;
        background-repeat: no-repeat;
        height: 300px;
        border: 1px solid #f2f2f2;
        overflow: hidden;
        cursor: pointer;

        @media (max-width: 767px) {
          height: 300px;
        }
      }
    }
  }

  .footer {
    padding: 60px 0;
    border-top: 1px solid black;
    margin-top: 100px;

    ul {
      margin-top: 20px;
      padding-left: 0;
      list-style: none;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      li {
        width: 50%;
        text-transform: uppercase;
        font-size: 11px;
        margin-bottom: 10px;
      }
    }

    img {
      max-width: 100px;
    }
  }
}

.image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

#price_asterisc,
#social-info {
  margin-top: 50px;
  text-align: left;
  padding: 0 15px;
}

.specifications {
  @media (max-width: 767px) {
    margin-bottom: 0 !important;
  }
}
</style>
